import { useCallback } from "react"
import { IOpenPanel } from "../../../../../Interfaces/IPanel"
import { ITurnoEdit } from "../../../../../Interfaces/auxiliar/ITurno"
import { UsePanelTurnoEliminar } from "./usePanelTurnoEliminar"
import { PanelFooter } from "../../../../../components/Panel/PanelFooter"
import { Panel } from "@fluentui/react"
import { Body1, makeStyles } from "@fluentui/react-components";
import { MessageBarResponse } from "../../../../../components/MessageBarResponse/MessageBarResponse"
import { ProgressBarLoading } from "../../../../../components/ProgressBarLoading/ProgressBarLoading"
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic"
import { Warning24Filled } from "@fluentui/react-icons";

export interface IPanelTurnoEliminar extends IOpenPanel {
  item: ITurnoEdit
}

export const PanelTurnoEliminar = (props: IPanelTurnoEliminar) => {
  const styles = useStyles();
  const { request, setRequest, deleteTurno, loading, reset, mensaje, status, contentShow, loadprogress } = UsePanelTurnoEliminar(props)
  const onRenderHeader = useCallback(
    () => (
      <PanelHeaderBasic
        subTextHeader=""
        textHeader="Eliminar Turno"
      />
    ),
    []
  );

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Eliminar"
          texto2={"Salir"}
          //disableButton={disableForm}
          onClick={deleteTurno}
          onDismiss={reset}
        />
      </>
    ),
    [request]
  );
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={reset}
      isFooterAtBottom
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
    >
      <div hidden={mensaje == ""}>
        <MessageBarResponse
          objetoResponse={{ codigo: status, mensaje: mensaje }}
          close={true}
        />
      </div>
      <div hidden={!loading}>
        <ProgressBarLoading></ProgressBarLoading>
      </div>
      <div hidden={loading}>
        {!mensaje && (
          <>
            {!loadprogress && (
              <>
                {contentShow && (
                  <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          Este turno será eliminada permanentemente, ¿Desea
                          eliminar el turno: {props.item.nombre}?
                        </Body1>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </Panel>)

}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    top: "100%",
    alignItems: "center",
  },

  warning: {
    color: " #eaa300",
    width: "60px",
    height: "60px",
  },
});
